<script lang="ts">
  import { type WorkoutPlayerType } from '@/Util/api';
  import * as Popover from '$lib/components/ui/popover';
  import { Button } from '@/lib/components/ui/button';
  import { workoutPlayerTypeToName } from '@/Common/constants';
  import { connectedWorkoutPlayers } from '@/Singletons/WorkoutPlayersWritable';
  import type { Exercise } from '@/Common/ActivityFunctions';
  import { DataStatus } from '@/Singletons/common';
  import { onMount } from 'svelte';

  export let workout: Exercise;
  export let disabled: boolean = false;

  // @ts-ignore
  const jq = window.jQuery;

  $: isLoading = $connectedWorkoutPlayers.status !== DataStatus.READY && $connectedWorkoutPlayers.status !== DataStatus.RESYNCING;
  let open = false;
  let icon = 'fa-paper-plane';

  async function doSend(workoutPlayerType: WorkoutPlayerType) {
    icon = 'fa-spinner-third animate-spin';
    open = false;
    const response = await connectedWorkoutPlayers.sendWorkoutToWorkoutPlayer(workoutPlayerType, workout);
    // The error toast is raised by connectedWorkoutPlayers.sendWorkoutToWorkoutPlayer.
    icon = response.cancelled ? 'fa-paper-plane' : response.success ? 'fa-check' : 'fa-xmark';
  }

  onMount(() => {
    jq('[data-toggle=tooltip]').tooltip({container: '#shadcn-ui-dialog-target'});
  });

</script>

{#if $connectedWorkoutPlayers.players?.length > 0}
  <Popover.Root portal="#shadcn-ui-dialog-target" bind:open>
    <!-- asChild rather than styling Popover.Trigger directly, so the click handler lands on a real
         button: bits-ui's own trigger re-dispatches a synthetic CustomEvent, and stopping that one
         wouldn't stop the underlying DOM click from reaching the card behind it. -->
    <Popover.Trigger asChild let:builder>
      <Button builders={[builder]} size="sm" variant="outline" disabled={disabled || isLoading} on:click={(e) => e.stopPropagation()}>
        <i class={`fa-solid fa-lg ${icon} text-xs mr-1`} /> Send Workout
      </Button>
    </Popover.Trigger>
    <Popover.Content align="start" class="flex flex-col gap-1 p-0 w-auto min-w-[150px]">
      {#each $connectedWorkoutPlayers.players as wp}
        {#if wp.type === 'garmin_connect' && workout.total_intervals > 50}
          <div class="flex w-full justify-start text-left" data-toggle='tooltip' title='Cannot send workouts with more than 50 intervals to Garmin Connect due to Garmin API limitations'>
            <Button disabled size="sm" variant="ghost" class="flex w-full justify-start text-left">
              <i class="fa-light fa-lg fa-paper-plane text-xs mr-1" /> {workoutPlayerTypeToName[wp.type]}
            </Button>
          </div>
        {:else}
          <Button
            variant="ghost"
            size='sm'
            class="flex w-full justify-start text-left"
            on:click={() => doSend(wp.type)}
          >
            <i class="fa-light fa-lg fa-paper-plane text-xs mr-1" /> {workoutPlayerTypeToName[wp.type]}
          </Button>
        {/if}
      {/each}
    </Popover.Content>
  </Popover.Root>
{/if}
